import config from '@shared/config';

export const UNAUTHORIZED_ERROR_CODE = 401;
export const ADMIN_REFRESH_TOKEN_URL = `${config.adminApiUrl}/api/v1/admin/auth/refresh`;
export const USER_REFRESH_TOKEN_URL = `${config.userApiUrl}/api/v1/user/auth/refresh`;
export const PUBLISHER_REFRESH_TOKEN_URL = `${config.publisherApiUrl}/api/v1/publisher/auth/refresh`;
